module.exports = __webpack_public_path__ + "static/img/about-img.90b86ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-img.jpg
// module id = pXBp
// module chunks = 1